import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthorizeInterceptor implements HttpInterceptor {
    constructor(private auth: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers: { [name: string]: string } = {};

        if (this.auth.sessionId) {
            headers.SessionKey = this.auth.sessionId;
        }

        const req = request.clone({
            setHeaders: {
                ...headers
            },
            withCredentials: true
        });

        return next.handle(req).pipe(
            catchError((error) => {
                return throwError(error);
            })
        );
    }
}
